var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFooterSocialLn = function SvgFooterSocialLn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.288,
    height: 15.287
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.422 15.287H.253V5.08h3.169ZM1.836 3.688a1.844 1.844 0 1 1 1.835-1.853 1.851 1.851 0 0 1-1.835 1.853Zm13.449 11.6h-3.163v-4.97c0-1.184-.024-2.7-1.648-2.7-1.648 0-1.9 1.286-1.9 2.617v5.054H5.407V5.08h3.04v1.393h.044a3.33 3.33 0 0 1 3-1.648c3.208 0 3.8 2.112 3.8 4.856v5.607Z"
  })));
};

export { SvgFooterSocialLn as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='15.288' height='15.287' viewBox='0 0 15.288 15.287'%3e%3cpath d='M3.422,15.288H.253V5.081H3.422ZM1.836,3.689A1.844,1.844,0,1,1,3.671,1.836,1.851,1.851,0,0,1,1.836,3.689Zm13.449,11.6H12.122V10.319c0-1.184-.024-2.7-1.648-2.7-1.648,0-1.9,1.286-1.9,2.617v5.054H5.407V5.081h3.04V6.474h.044a3.33,3.33,0,0,1,3-1.648c3.208,0,3.8,2.112,3.8,4.856v5.607Z' transform='translate(0 -0.001)'/%3e%3c/svg%3e";